/**
 * Identificador da API. No JSON é sempre uma string UUID, por isso o tipo é `string`;
 * o objeto `Guid` mantém as poucas operações que o portal usava do guid-typescript.
 */
export type Guid = string;

export const Guid = {
    EMPTY: '00000000-0000-0000-0000-000000000000' as Guid,
    parse: (value: string): Guid => value,
    create: (): Guid => crypto.randomUUID(),
    isEmpty: (value: Guid | null | undefined): boolean => !value || value === Guid.EMPTY,
};
